import axios from "axios";

export const ApiInstance = () => {
    const isPanelIFrame = () => {
        return window.location !== top.location && !window.location.hostname.toString().includes('my-pro-office')
    }

    const apiInstance = () => {
        return axios.create({
            headers: {
                'Request-Source': isPanelIFrame() ? 'CRM' : 'SITE',
                'X-Requested-With': 'xmlhttprequest',
                'EIQ-Payload': 'true',
            }
        });
    }

    return {
        isPanelIFrame,
        apiInstance,
    }
}